<template lang="jade">
  include ./mixin.jade
  +simpleGetButton('dxGetAbout')
  +simpleGetButton('dxGetBaudrate')
  +simpleGetButton('dxGetTimeZoneOptions')
  +simpleGetButton('dxGetTimeZone')
  .row
    .col-xs-12
      fieldset
        legend dxSetTimeZone
        +simpleReadOnlyInput('timezone.id')
        +simpleReadOnlyInput('timezone.offset')(number)
        +simpleReadOnlyInput('timezone.dstSavings')(number)
        +readOnlyCheckbox('timezone.useDaylight')(type='checkbox')
        select(v-model="timezone")
          option(v-for="opt in timezoneOpts" v-bind:value="opt") {{opt.id}}
        button(@click="dxSetTimeZone") dxSetTimeZone
  +simpleGetButton('dxGetNetworkSettings')
  .row
    .col-xs-12
      fieldset
        legend dxSetNetworkSettings
        div(v-for="(key, val) in networkSettings")
          span {{ key }}:
          input(type='text' v-model='val')
        div
          span dhcpEnabled:
          input(type='checkbox' v-model='dhcpEnabled')

        button(@click="dxSetNetworkSettings") dxSetNetworkSettings
  +simpleGetButton('dxGetPower')
  .row
    .col-xs-12
      fieldset
        legend dxSetPower
        div
          span power status:
        button(@click="dxSetPower('on')") dxSetPower( on )
        button(@click="dxSetPower('off')") dxSetPower( off )
  +simpleGetButton('dxResetDevice')
  +simpleGetButton('dxDefaultDevice')
  +simpleGetButton('dxRollbackDevice')
  .row
    .col-xs-12
      fieldset
        legend dxUpdateFirmware
        div
          span url:
          input(type='text' v-model='firmwareUrl')
        button(@click="dxUpdateFirmware") dxUpdateFirmware
  +simpleGetButton('dxGetEmailGroups')
  .row
    .col-xs-12
      fieldset
        legend dxSetEmailGroups
        div
          span gid:
          input(type='text' v-model='emailGroup.gid')
        div
          span name:
          input(type='text' v-model='emailGroup.content.name')
        .form-group
          label accounts:
          textarea.form-control(v-model='emailGroup.content.accounts')
        button(@click="dxSetEmailGroups") dxSetEmailGroups
  +simpleGetButton('dxGetSMSGroups')
  .row
    .col-xs-12
      fieldset
        legend dxSetSMSGroups
        div
          span gid:
          input(type='text' v-model='smsGroup.gid')
        div
          span name:
          input(type='text' v-model='smsGroup.content.name')
        .form-group
          label accounts:
          textarea.form-control(v-model='smsGroup.content.accounts')
        button(@click="dxSetSMSGroups") dxSetSMSGroups
  +simpleGetButton('dxGetSchedules')
  //- ============== dxSetSchedules ====================
  .row
    .col-xs-12
      fieldset
        legend dxSetSchedules
        div
          h3
            |schedule
            input(type="number" v-model="dxSetSchedules.no" max='10' min='1')
          span
            |enabled:
            input(type="checkbox" v-model="dxSetSchedules.params.enabled")
          div
            span
              |name:
              input(type="text" v-model="dxSetSchedules.params.name")
          div
            span Actions
            span
              select(v-model='dxSetSchedules.params.action')
                option(value='Power RESET') Power RESET
                option(value='Power ON') Power ON
                option(value='Power OFF') Power OFF
                option(value='Sequence ON') Sequence ON
                option(value='Sequence OFF') Sequence OFF
          div
            span Banks
            span(v-for="i in 3")
              input(type="checkbox" v-bind:value="(i+1).toString()" v-model="dxSetSchedules.params.banks")
              |{{ i+1 }}
          .row
            .col-xs-6
              | hours
              input(type="number" max='23' v-model="dxSetSchedules.params.time.hours")
            .col-xs-6
              | minutes
              input(type="number" max='59' v-model="dxSetSchedules.params.time.minutes")
            .col-xs-12
              | days:
              span(v-for='(key,day) in weekDays')
                input(type="checkbox" v-bind:value="day" v-model='dxSetSchedules.params.time.days')
                label {{day}}
        button(@click="dxSetSchedulesHandler") dxSetSchedules
  +simpleGetButton('dxGetEvents')
  //- ============== dxSetEvents ======================
  .row
    .col-xs-12
      fieldset
        legend dxSetEvents
        div
          h3
            | Event no.
            input(type='number' min="1" max='10' v-model='dxSetEvents.no')
          div
            | enabled:
            input(type="checkbox" v-model='dxSetEvents.content.enabled')
          div
            | event.name
            input(type="text" v-model="dxSetSchedules.params.name")
          div
            | event.key: {{ dxSetEvents.content.event.key }}
            radio(
              type="info"
              v-bind:checked.sync="dxSetEvents.content.event.key"
              v-for='key in dxSetEvents.keys'
              v-bind:value="key") {{ key }}
          div
            | event.condition:
            label.radio-inline(v-for='condition in dxSetEvents.conditions')
              input(type='radio' v-bind:value="condition" v-model='dxSetEvents.content.event.condition')
              | {{ condition }}
          div
            | event.value
            input(type="text" v-model="dxSetEvents.event.value")
          div
            fieldset
              legend  Actions
              div(v-for="type in dxSetEvents.actionTypes")
                fieldset
                  legend
                    |{{ type.action }}
                    input(type="checkbox" v-model='type.selected')
                  div(v-if='type.selected && type.show_checkbox_power')
                    //- this is normal check box selections for power on,off,reset
                    | Targets:
                    span(v-for="i in 4" )
                      input(type="checkbox" v-bind:value="i.toString()" v-model="type.targets")
                      span(v-if="i") bank {{ i }}
                      span(v-else) input

                  div(v-if='type.selected && type.show_checkbox_dio')
                    //- this is normal check box selections for do high, do low
                    | Targets:
                    span(v-for="i in 2" )
                      input(type="checkbox" v-bind:value="i.toString()" v-model="type.targets")
                      span DO {{ i+1 }}

                  .form-group(v-if='type.selected && type.show_targets_string')
                    //- this is user input enter ther targets
                    label accounts:
                    textarea.form-control(v-model='type.targets_string')
                    div(v-if='type.show_value')
                      //- this is normal value input for seq on, off(5,6)
                      | Delay Time:
                      input(v-model="type.value")
        button(@click="dxSetEventsHandler") dxSetEvents

</template>

<script>
  import { radio } from 'vue-strap'
  import { getTimezoneOptions } from './timezoneOption.js'

  export default {
    components: {
      radio
    },
    data: () => ({
      timezoneOpts: getTimezoneOptions(),
      timezone: {
        'id': 'GMT-6:00(Chicago, Dallas, Huston, Mexico City, New Orleans)',
        'offset': -21600,
        'dstSavings': 3600,
        'useDaylight': true
      },
      networkSettings: {
        deviceName: '',
        deviceIpAddress: '',
        deviceSubnetMask: '',
        deviceDefaultGateway: '',
        dnsServer1: '',
        dnsServer2: '',
        webPagePort: ''
      },
      dhcpEnabled: false,
      firmwareUrl: '',
      emailGroup: {
        gid: '1',
        content: {
          name: 'admins',
          accounts: 'joe@gmail.com;lisa@gmail.com'
        }
      },
      smsGroup: {
        gid: '1',
        content: {
          name: 'admins',
          accounts: '+886972345678;+886912345678;'
        }
      },
      weekDays: ['mon', 'tue', 'wed', 'thr', 'fri', 'sat', 'sun'],
      dxSetSchedules: {
        no: '1',
        params: {
          enabled: true,
          name: 'hahaha',
          action: 'Power RESET',
          banks: ['1'],
          time: {
            hours: 8,
            minutes: 0,
            days: ['mon', 'tue']
          }
        }
      },
      dxSetEvents: {
        no: '1',
        keys: ['Voltage', 'Current', 'Connection', 'Power', 'DI'],
        conditions: ['>', '>=', '==', '<=', '<'],
        actionTypes: [
          'Power RESET', 'Power ON', 'Power OFF', // < 3 power
          'DO High', 'DO Low', // when < 5 : checkbox
          'Email', 'SMS', // when 5 ~ 6 : only textarea
          'Sequence ON', 'Sequence OFF' // when >= 7 : show value
        ].map((action, index) => ({
          selected: false,
          show_checkbox_power: index < 3,
          show_checkbox_dio: index >= 3 && index < 5,
          show_targets_string: index >= 5,
          show_value: index >= 7,
          action,
          value: '',
          targets_string: 'admin;user1',
          targets: []
        })),
        content: {
          enabled: false,
          name: 'test',
          event: {
            key: 'Voltage',
            condition: '>=',
            value: '110',
            source: '2'
          },
          actions: []
        }
      }
    }),
    methods: {
      sendAPI (cmd, params) {
        this.$dispatch('sendAPI', cmd, params)
      },
      dxSetTimeZone () {
        this.sendAPI('dxSetTimeZone', {
          timezone: this.timezone
        })
      },
      dxSetNetworkSettings () {
        let params = this.networkSettings
        params.dhcpEnabled = this.dhcpEnabled
        console.log(params)
        this.sendAPI('dxSetNetworkSettings', params)
      },
      dxSetPower (str) {
        this.sendAPI('dxSetNetworkSettings', { power: str })
      },
      dxUpdateFirmware () {
        this.sendAPI('dxUpdateFirmware', { url: this.firmwareUrl })
      },
      dxSetEmailGroups () {
        this.sendAPI('dxSetEmailGroups', {
          entries: {
            [this.emailGroup.gid]: this.emailGroup.content
          }
        })
      },
      dxSetSMSGroups () {
        this.sendAPI('dxSetSMSGroups', {
          entries: {
            [this.smsGroup.gid]: this.smsGroup.content
          }
        })
      },
      dxSetSchedulesHandler () {
        if (this.dxSetSchedules.no > 10 || this.dxSetSchedules.no < 1) return window.alert('only 1-10 schedules number allowed')
        this.sendAPI('dxSetSchedules', {
          entries: {
            [this.dxSetSchedules.no]: this.dxSetSchedules.params
          }
        })
      },
      dxSetEventsHandler () {
        let { content, no } = this.dxSetEvents
        content.actions = this.dxSetEvents.actionTypes
          .map((T, index) => ({
            action: T.selected && T.action,
            value: T.value,
            targets: T.show_targets_string ? T.targets_string.split(';') : T.targets
          }))
          .filter(T => T.action) // filter : not select
        if (content.length === 0) {
          window.alert('at least one action, please!')
        } else {
          this.sendAPI('dxSetEvents', {
            entries: {
              [no]: content
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// general.vue?c5bc036c